/* eslint-disable */

import { useNavigate } from 'react-router-dom'
import { useModal } from '../../hooks/use-modal-store'
import FullPagePopupLayout from './FullPagePopupLayout'

const MandatePopups = () => {
  const { isOpen, onClose, type, data } = useModal()
  const navigate = useNavigate()

  const isModalOpen = isOpen && type === 'openMandatePopup'
  const actionCount = Number(Boolean(data?.closeButton)) + Number(Boolean(data?.showExploreButton))

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity || 'notice'}
      title={data?.title || 'Mandate update'}
      message={data?.message}
      actionsClassName={actionCount < 2 ? 'fabits-global-popup-actions-single' : undefined}
      actions={
        <>
          {data?.closeButton && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-secondary'
              onClick={() => {
                onClose(), navigate(data?.redirectBackTo)
              }}
            >
              Close
            </button>
          )}
          {data?.showExploreButton && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={() => {
                onClose(), navigate(data?.forwardTo)
              }}
            >
              {data?.exploreButtonText}
            </button>
          )}
        </>
      }
    />
  )
}

export default MandatePopups
